import styled from "styled-components";
import { TableCell, TableContainer as MuiTableContainer } from '@mui/material';

export const StyledTableContainer = styled(MuiTableContainer)`
    scrollbar-width: thin;
    scrollbar-color: #fe2f67 #f1f1f1;
    border-radius: 10px;
    background: #fff;
    overflow-x: auto;
    width: 50%;
    margin: 0 auto;
    padding: 0;

    & table {
      table-layout: auto;
      width: 100%;
    }

    &::-webkit-scrollbar {
        width: 0.5rem;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 0.625rem;
    }
    &::-webkit-scrollbar-thumb {
        background: #fe2f67;
        border-radius: 0.625rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #e8245a;
    }
`;

export const TableFooterStyled = styled.div`
  background: #faf7fa;
  border-top: 1px solid #f3c2d1;
  padding: 0.5rem 1.5rem;
  border-radius: 0 0 10px 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #fe2f67;
  font-weight: 700;
  
  .MuiTablePagination-root,
  .MuiTablePagination-toolbar,
  .MuiTablePagination-selectLabel,
  .MuiTablePagination-input,
  .MuiTablePagination-displayedRows,
  .MuiSelect-select,
  .MuiSvgIcon-root {
    color: #fe2f67 !important;
    fill: #fe2f67 !important;
    font-weight: 700 !important;
  }
  
  .MuiTablePagination-actions button {
    color: #fe2f67 !important;
    font-weight: 700 !important;
  }
`;

export const TableCellCondensed = styled(TableCell)`
    padding-top: 0.625rem !important;
    padding-bottom: 0.625rem !important;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    text-align: left !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
